module.exports = __webpack_public_path__ + "static/media/mobileScreenshot07.93475fae.jpg";